import {INFO_BACKGROUND, INFO_COLOR} from "../../../../themes/themeConfigurator";

const styles = theme => ({
  error: {
    color: theme.palette.error.main,
  },
  // --- Portfolio cards ---
  portfolioCardItem: {
    flexShrink: 0,
  },
  portfolioCard: {
    position: 'relative',
    padding: 16,
    borderRadius: 8,
    border: '1px solid #D9DCDF',
    cursor: 'pointer',
    transition: 'all 0.15s ease',
    width: 400,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    fontFamily: 'Roboto-Regular',
    gap: `${theme.spacing(1)}px`,
    '&:hover': {
      boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.15), 0px 2px 6px 2px rgba(0, 0, 0, 0.10)',
    },
    '&:focus': {
      outline: 'none',
    },

    [theme.breakpoints.only('xs')]: {
      width: 280,
    }
  },
  portfolioCardSelected: {
    backgroundColor: '#E0F2FC',
  },
  portfolioCardError: {
    borderColor: theme.palette.error.main,
    animation: '$errorPulse 1s ease-in-out',
    '&:hover': {
      borderColor: theme.palette.error.main,
    },
  },
  '@keyframes errorPulse': {
    '0%': { boxShadow: 'none' },
    '50%': { boxShadow: `0 0 0 4px ${theme.palette.error.main}33` },
    '100%': { boxShadow: 'none' },
  },
  portfolioCardName: {
    fontSize: 18,
    fontFamily: 'Roboto-Bold',
    lineHeight: 1.3,
  },
  portfolioCardBadge: {
    position: 'absolute',
    top: 8,
    right: 8,
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: theme.palette.primary.main,
  },

  totalValueChip: {
    height: '100%',
    textAlign: 'center',
    fontSize: 18,
    color: `${INFO_COLOR} !important`,
    background: `${INFO_BACKGROUND} !important`,

    [theme.breakpoints.up('sm')]: {
      float: 'right',
      minWidth: 180,
      width: 'auto',
    }
  },
  totalValueChipSubHeader: {
    margin: 0,
    fontFamily: 'Roboto-Regular',
    fontSize: 12,
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    display: 'block',
  },

  // --- Tabs ---
  tabError: {
    color: `${theme.palette.error.main} !important`,
  },
  tabBadge: {
    '& .MuiBadge-badge': {
      position: 'static',
      transform: 'none',
      marginLeft: 8,
      fontFamily: 'Roboto-Bold',
    },
    alignItems: 'center',
  },
  tabBadgeSmall: {
    fontSize: 12,
  },
  chip: {
    fontSize: 12,
    height: 22,
  },
  tabTotal: {
    fontSize: 12,
    color: '#838A93',
    paddingLeft: 4,
    fontFamily: 'Roboto-Regular',
    textShadow: 'none'
  },

  // --- Action buttons ---
  actionButtonsContainer: {
    marginBottom: 16,
  },

  // --- Loading ---
  loadingIndicator: {
    color: theme.palette.primary.main
  },
  loadingContainer: {
    width: '100%',
    height: 'calc(100vh - 420px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
});

export default styles;
